<template>
	<b-modal
		:visible="showModal"
		@hide="closeModal"
		id="interrupted-interview-modal"
		hide-footer
		hide-header
		centered
		no-close-on-backdrop
		dialog-class="interrupted-modal-dialog"
	>
		<div class="interrupted-modal-content">

			<div class="modal-grid-container">
				<!-- Left Text Section -->
				<div class="modal-left-section">
					<div class="modal-title-wrapper">
						<img src="../../assets/img/homepage/danger-yellow.svg" alt="warning" class="warning-icon" />
						<h3 class="modal-title-text">Your Interview was interrupted</h3>
					</div>
					
					<p class="modal-subtitle">
						You can choose to continue with the interview or end the interview
					</p>

					<!-- Mobile-only bot image (between subtitle and instructions) -->
					<div class="mobile-bot-section">
						<img src="../../assets/img/homepage/bot-interview-mobile.svg" alt="bot illustration" class="mobile-bot-image" />
					</div>

					<div class="modal-instruction-section">
						<h4 class="instruction-header">Please Ensure that</h4>
						<ul class="instruction-list">
							<li>Ensure to Review and edit each section as highlighted.</li>
							<li>Save or Download your resume on completion of the review</li>
						</ul>
					</div>

					<div class="modal-actions">
						<b-button class="btn-end-interview" @click="endInterview">
							End Interview
						</b-button>
						<b-button class="btn-resume-interview" @click="resumeInterview">
							Resume Interview
						</b-button>
					</div>
				</div>

				<!-- Right Illustration Section -->
				<div class="modal-right-section">
					<img src="../../assets/img/homepage/interv-bot.svg" alt="bot illustration" class="modal-bot-image" />
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: "InterruptedInterviewModal",
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		closeModal() {
			this.$emit("update:showModal", false);
		},
		endInterview() {
			this.$emit("end");
			this.closeModal();
		},
		resumeInterview() {
			this.$emit("resume");
			this.closeModal();
		},
	},
};
</script>

<style>
.interrupted-modal-dialog {
	max-width: 880px !important;
}

.interrupted-modal-dialog .modal-content {
	border: none !important;
	border-radius: 16px !important;
	overflow: hidden !important;
}

.interrupted-modal-dialog .modal-body {
	padding: 30px 0px 0px 30px !important;
}

.interrupted-modal-content {
	position: relative;
	background-color: #fff;
}

.modal-close-btn {
	position: absolute;
	top: 16px;
	right: 16px;
	width: 18px;
	cursor: pointer;
	z-index: 10;
}

.modal-grid-container {
	display: grid;
	grid-template-columns: 1.2fr 0.8fr;
	align-items: stretch;
}

.modal-left-section {
	padding-bottom: 32px;
	display: flex;
	flex-direction: column;
}

.modal-title-wrapper {
	display: flex;
	align-items: center;
	gap: 10px;
}

.warning-icon {
	width: 24px;
	height: 24px;
}

.modal-title-text {
	color: #F28B2B;
	font-size: 28px;
	font-weight: 500;
	margin: 0;
	font-family: "Lato", sans-serif;
}

.modal-subtitle {
	color: #7A7A7A;
	font-size: 16px;
	font-weight: 400;
	margin-top: 12px;
	margin-bottom: 24px;
	font-family: "Lato", sans-serif;
}

.modal-instruction-section {
	margin-bottom: 32px;
}

.instruction-header {
	color: #344054;
	font-size: 16px;
	font-weight: 500;
	margin-bottom: 12px;
	font-family: "Lato", sans-serif;
}

.instruction-list {
	list-style: none;
	padding-left: 0;
	margin: 0;
}

.instruction-list li {
	position: relative;
	padding-left: 20px;
	margin-bottom: 10px;
	font-size: 16px;
	font-weight: 500;
	color: #3A3C40;
	font-family: "Lato", sans-serif;
	line-height: 1.4;
}

.instruction-list li::before {
	content: "";
	position: absolute;
	left: 4px;
	top: 6px;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: #20639b;
}

.modal-actions {
	display: flex;
	gap: 16px;
	margin-top: auto;
}

.btn-end-interview {
	background-color: #ffffff !important;
	border: 1px solid #ced4da !important;
	color: #333333 !important;
	border-radius: 20px !important;
	padding: 8px 24px !important;
	font-size: 14px !important;
	font-weight: 600 !important;
	font-family: "Montserrat", sans-serif !important;
	box-shadow: none !important;
}

.btn-resume-interview {
	background-color: #20639b !important;
	border: 1px solid #20639b !important;
	color: #ffffff !important;
	border-radius: 20px !important;
	padding: 8px 24px !important;
	font-size: 14px !important;
	font-weight: 600 !important;
	font-family: "Montserrat", sans-serif !important;
	box-shadow: none !important;
}

.modal-right-section {
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	height: 100%;
}

.modal-bot-image {
	max-width: 100%;
	height: auto;
	object-fit: contain;
	display: block;
	margin-bottom: -1px;
	margin-top:3rem;
}
/* Mobile bot image - hidden on desktop */
.mobile-bot-section {
	display: none;
}

@media (max-width: 767px) {
	/* Make modal full-page on mobile */
	.interrupted-modal-dialog {
		max-width: 100% !important;
		margin: 0 !important;
		height: 100% !important;
	}
	.interrupted-modal-dialog .modal-content {
		border-radius: 0 !important;
		height: 100% !important;
		min-height: 100vh !important;
	}
	.interrupted-modal-dialog .modal-body {
		padding: 24px 20px 20px 20px !important;
		display: flex !important;
		flex-direction: column !important;
		height: 100% !important;
	}
	.interrupted-modal-content {
		padding: 0;
		display: flex;
		flex-direction: column;
		height: 100%;
		flex: 1;
	}

	/* Single column layout */
	.modal-grid-container {
		grid-template-columns: 1fr;
		gap: 0;
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	/* Hide desktop right illustration */
	.modal-right-section {
		display: none !important;
	}

	/* Show mobile bot image */
	.mobile-bot-section {
		display: flex;
		justify-content: center;
		align-items: center;
		flex: 1;
		padding: 16px 0 20px 0;
		border-bottom: 1px dashed #8C8C8C4D;
	}
	.mobile-bot-image {
		max-width: 70%;
		height: auto;
		object-fit: contain;
	}

	/* Mobile font sizes per Figma */
	.modal-title-text {
		font-size: 20px !important;
	}
	.modal-subtitle {
		font-size: 16px !important;
		margin-bottom: 0;
	}
	.modal-instruction-section {
		margin-top: auto;
		padding-top: 20px;
	}
	.instruction-header {
		color: #20639B !important;
		font-size: 14px !important;
	}
	.instruction-list li {
		font-size: 14px !important;
	}

	.modal-left-section {
		padding-bottom: 0;
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.modal-actions {
		margin-top: auto;
		padding-top: 20px;
		border-top: 1px solid #ECECEC;
	}
}
</style>
